import React from 'react';
import Help from '@mui/icons-material/Help';
import { Grid } from '@mui/material';

import { useComponent } from 'hooks';
import { Container, ContainerItem, Text, Tooltip } from 'ui';

export interface DrawerInfoItemProps extends Record<string, unknown> {
  label: string;
  value?: string;
  tooltip?: string;
  fullWidth?: boolean;
}

export const DrawerInfoItem: React.FC<DrawerInfoItemProps> = useComponent((props) => {
  return (
    <Grid item xs={12} md={props.fullWidth ? 12 : 6}>
      <Container align="center" height="fit-content" margin="0" padding={0}>
        <ContainerItem flex align="center" margin="0" padding={0}>
          <Text sx={{ fontWeight: 700, fontSize: '13px', color: '#757783' }} content={props.label} />
        </ContainerItem>
        {props.tooltip ? (
          <ContainerItem padding={0} align="center" flex margin="-3px 0 0 2px">
            <Tooltip variant="text" title={props.tooltip} placement="right">
              <Help color="primary" />
            </Tooltip>
          </ContainerItem>
        ) : null}
      </Container>
      <Text sx={{ wordBreak: 'break-word' }} content={props.value ?? '--'} />
    </Grid>
  );
});
